import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FirebaseUser, IdTokenResult } from '@astrade/core';

@Component({
  selector: 'astrade-dropship-side-menu',
  templateUrl: './dropship-side-menu.component.html',
  styleUrls: ['./dropship-side-menu.component.scss']
})
export class DropshipSideMenuComponent implements OnInit {

  @Input() user: FirebaseUser;
  @Input() idTokenResult: IdTokenResult;

  @Output() loginClick = new EventEmitter<void>();
  @Output() logoutClick = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }
}
